import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UISection from 'UIComponents/section/UISection';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApplicationAccessDenied() {
  return /*#__PURE__*/_jsx(UISection, {
    use: "island",
    children: /*#__PURE__*/_jsx(UIFlex, {
      justify: "around",
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "600px",
        children: /*#__PURE__*/_jsx(UIErrorMessage, {
          illustration: "lock",
          illustrationProps: {
            width: 200
          },
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'disabledMessage.common.applicationAccessDenied.title'
          }),
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'disabledMessage.common.applicationAccessDenied.message'
            })
          })
        })
      })
    })
  });
}